var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "M7.598.273c-3.762 0-6.75 3.059-6.75 6.75 0 2.532.808 3.305 5.308 10.477a1.677 1.677 0 0 0 2.848 0c4.5-7.172 5.344-7.945 5.344-10.477 0-3.726-3.059-6.75-6.75-6.75"
  })));
};
export default SvgPin;